import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CldrIntlService, IntlService } from '@progress/kendo-angular-intl';
import { Observable } from 'rxjs';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
    constructor(private intlService: IntlService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const lang = (this.intlService as CldrIntlService).localeId;
        if (lang) {
            request = request.clone({
                setHeaders: {
                    'Accept-Language': lang
                }
            });
        }

        return next.handle(request);
    }
}
